/* Tech Premium — theme.js */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Collection sort */
  document.querySelectorAll('[data-sort-by]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Product gallery thumbs */
  function setMainImage(root, thumb) {
    var main = root.querySelector('[data-main-image]');
    if (!main || !thumb) return;
    var src = thumb.getAttribute('data-full');
    var img = main.querySelector('img');
    if (img && src) {
      img.src = src;
      img.removeAttribute('srcset');
      img.alt = thumb.getAttribute('data-alt') || img.alt;
    }
    root.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    setMainImage(thumb.closest('[data-product]'), thumb);
  });

  /* Variant picker */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var moneyFormat = root.getAttribute('data-money-format');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var addText = addBtn ? addBtn.querySelector('span') : null;
    var priceEl = root.querySelector('[data-price]');
    var sectionId = root.getAttribute('data-section');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; if (addText) addText.textContent = 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? addBtn.getAttribute('data-add-text') : addBtn.getAttribute('data-soldout-text');
      }
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(variant.price, moneyFormat) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>';
          priceEl.classList.add('price--sale');
        } else {
          priceEl.classList.remove('price--sale');
        }
        priceEl.innerHTML = html;
      }
      if (variant.featured_media) {
        var thumb = root.querySelector('[data-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) setMainImage(root, thumb);
      }
      if (sectionId && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-option] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
  });
})();
